// extracted by mini-css-extract-plugin
module.exports = {"amazon-sale-C":"C_amazon-sale-C__PJeoX"};